import { clsx } from 'clsx';
import { PropsWithChildren } from 'react';

export function FormFilters({
  children,
  className,
  testid,
}: PropsWithChildren<{ className?: string; testid?: string }>) {
  return (
    <form className={clsx('relative flex my-5 gap-3 flex-grow items-center', className)} data-testid={testid}>
      {children}
    </form>
  );
}
